import { api } from './_httpClient'

const listStats = async () => api.get('/dashboard/list')

export { listStats }
